import { auth } from '@/shared/lib';
import { addLocale, useLocale } from 'ttag';

// Vite-native eager glob loader — replaces webpack dynamic require().
// Pattern: app/i18n/<locale>/<locale>.po.json
const translations = import.meta.glob('./*/*.po.json', { eager: true, import: 'default' });

// *: Setup
const locale = auth.getLocale();

if (locale !== 'en') {
  const translationsObj = translations[`./${locale}/${locale}.po.json`];
  if (translationsObj) {
    addLocale(locale, translationsObj as any);
    useLocale(locale);
  }
}
